module.exports = __webpack_public_path__ + "static/media/Jc.599a46ef.png";